import { useQuery } from "@tanstack/react-query";
import { checkBlobIndexed } from "@/services/ai-search/checkBlobIndexed";

/**
 * Custom hook to check if a blob is indexed in Azure AI Search
 * @param blobName - The name of the blob to check
 * @returns Query result with isIndexed boolean and loading state
 */
export function useBlobIndexStatus(blobName: string) {
  return useQuery({
    queryKey: ["blobIndexStatus", blobName],
    queryFn: () => checkBlobIndexed(blobName),
    staleTime: 1000 * 60 * 5, // 5 minutes - assume indexing status doesn't change frequently
    retry: 1, // Only retry once on failure
    refetchOnWindowFocus: true,
  });
}
